import { NgModule } from "@angular/core";
import { SharedModule } from "@app/view/shared";
import { BookingRoutingModule } from "@app/view/booking/booking-routing.module";
import { BookingContainerComponent } from "./booking-container/booking-container.component";
import { BookingHomeComponent } from "./booking-home/booking-home.component";
import { VisitBookingComponent } from "./visit-booking/visit-booking.component";
import { VisitFloatingComponent } from "./visit-floating/visit-floating.component";
import { AvailabilityInfoDisplayComponent } from "./availability-info-display/availability-info-display.component";
import { BookingConfirmComponent } from "./booking-confirm/booking-confirm.component";
// import { NgxLoadingModule } from 'ngx-loading-temp';
import { JobBookingComponentComponent } from "./job-booking-component/job-booking-component.component";
import { JobsModule } from "@app/view/jobs/jobs.module";
import { BookingProgressDialogComponent } from "./booking-progress-dialog/booking-progress-dialog.component";
import { BookingOutcomeComponent } from "./booking-outcome/booking-outcome.component";
import { DataViewModule } from "@app/view/data-view/data-view.module";
import { BookingHistoryComponent } from "./booking-history/booking-history.component";
import { VisitPropertyListComponentComponent } from "./visit-property-list-component/visit-property-list-component.component";

@NgModule({
  imports: [
    SharedModule,
    // NgxLoadingModule.forRoot({}),
    BookingRoutingModule,
    JobsModule,
    DataViewModule,
    BookingContainerComponent,
    BookingHomeComponent,
    VisitBookingComponent,
    VisitFloatingComponent,
    AvailabilityInfoDisplayComponent,
    BookingConfirmComponent,
    JobBookingComponentComponent,
    BookingProgressDialogComponent,
    BookingOutcomeComponent,
    BookingHistoryComponent,
    VisitPropertyListComponentComponent
  ]
})
export class BookingModule {}
